<template>
  <div class="resource-discount-item">
    <div class="li2-cover-box">
      <div
        :style="'background-image: url(' + item2.fileCoverPath + ');'"
        class="li2-cover"
      ></div>
      <p class="resource-pages2">{{ item2.pages }}页</p>
    </div>
    <div class="li2-info">
      <p class="li2-title">
        {{ item2.title }}
      </p>
      <div class="countDown-box">
        距结束 <span>{{ day }}</span
        >天 <span>{{ hour }}</span
        >时 <span>{{ minute }}</span
        >分 <span>{{ second }}</span
        >秒
      </div>
      <div class="li2-bottom">
        <div class="li-value">
          <span class="new-value">{{
            item2.activityState == 1 ? item2.activityInfo.activityPriceName : ""
          }}</span>
          <span class="old-value">{{ item2.priceName }}</span>
        </div>
        <div class="li-date">{{ item2.downloads | numberChange }}下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import numberHandler from "../../../mixin/numberHandle.js";
import setCountDown from "../../../mixin/setCountDown.js";
export default {
  name: "ShopCenterAdminWebMResourceDiscountItem",
  props: {
    item2: {
      type: [Object, String],
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mixins: [numberHandler, setCountDown],
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.resource-discount-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #e6e6e6;
  &:last-child {
    border: 0;
  }

  .li2-cover-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 69px;
    height: 97px;
    margin: 0px 8px;
    background: url(../../../assets/images/m-decoration/m-resource-cover-border.png)
      no-repeat center center;
    background-size: 100% 100%;

    .li2-cover {
      width: 90%;
      height: 72px;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .resource-pages2 {
      position: absolute;
      right: 0px;
      bottom: 0px;
      padding: 3px;
      border-radius: 3px;
      opacity: 0.5;
      background: #000;
      color: #fff;
      font-size: 12px;
      line-height: 12px;
    }
  }
  .li2-info {
    width: 234px;
    // height: 71px;
    .li2-title {
      height: 40px;
      color: #3a3d4b;
      font-size: 15px;
      font-weight: 500;
      line-height: normal;
      // 两行超出省略
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    .countDown-box {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 5px 10px;
      margin: 9px 0;
      border-radius: 10px;
      background: #fff2ee;
      color: #fe480d;
      font-size: 12px;
      line-height: 12px; /* 100% */
    }
    .li2-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .li-value {
        .new-value {
          color: #fe4509;
          font-size: 12px;
          font-weight: 500;
          line-height: 12px; /* 100% */
        }
        .old-value {
          margin-left: 8px;
          color: #b4becd;
          font-size: 12px;
          text-decoration: line-through;
        }
      }
      .li-date {
        color: #8895a9;
        font-size: 12px;
        line-height: normal;
      }
    }
  }
}
</style>
